import styled, { css } from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

const slideInKeyFrames = css`
  @keyframes slide-in {
    0% {
      opacity: 0;
      transform: translateX(100%);
    }
    100% {
      opacity: 1;
      transform: translateX(0%);
    }
  }
`;

const slideOutKeyFrames = css`
  @keyframes slide-out {
    0% {
      opacity: 1;
      transform: translateX(0%);
    }
    100% {
      opacity: 0;
      transform: translateX(100%);
    }
  }
`;

export const ToastWrapper = styled.div`
  max-width: 600px;
  display: flex;
  justify-content: space-between;
  padding: 14px 16px;
  align-items: center;
  border-radius: 8px;
  background: ${({ bgolor, theme }) =>
    bgolor === 'error' ? theme.colors.redLight : theme.colors.greenLight};
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.16);
  animation: ${({ dismissed }) => (dismissed ? 'slide-out' : 'slide-in')} 0.4s ease-in-out forwards;

  ${({ dismissed }) => (dismissed ? slideOutKeyFrames : slideInKeyFrames)}
`;

export const ToastIcon = styled.img`
  width: 24px;
  height: 24px;
`;

export const ToastMessage = styled(typography.TitleTwoTypography)`
  margin: 0 12px;
`;

export const ToastCloseBtn = styled.div`
  &:hover {
    cursor: pointer;
  }

  &:before {
    content: '\\e91f';
    font-family: Icomoon;
    font-size: 22px;
    color: ${({ theme }) => theme.colors.grey600};
  }
`;

export const ToastsContainerWrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;
  row-gap: 12px;
  position: fixed;
  z-index: 9999;
  bottom: 16px;
  right: 16px;
`;
